module.exports = __webpack_public_path__ + "img/2A.81bd3958.jpg";